import { useState } from "react";
import { authenticatedFetch } from "./api";
import "./ShopifyConverter.css";

function VariantInventoryGenerator() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!file) {
      alert("Please upload a file.");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await authenticatedFetch(
        "/variant-inventory-generator",
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) throw new Error("Failed to generate inventory.");

      const contentType = response.headers.get("content-type");

      if (contentType && contentType.includes("application/json")) {
        // Backend returned JSON (e.g., error)
        const data = await response.json();
        alert(data.error || "Unknown response from server.");
      } else {
        // Backend returned file → download
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        // Save with original filename + "_variant_inventory"
        a.download = file.name.replace(/\.[^/.]+$/, "") + "_variant_inventory.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error(error);
      alert("Error generating variant inventory. Check backend logs.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="converter-container">
      <h2>Variant Inventory Generator</h2>

      <div className="form-group">
        <label>Upload Inventory File</label>
        <input type="file" onChange={(e) => setFile(e.target.files[0])} />
      </div>

      <button onClick={handleSubmit} disabled={loading}>
        {loading ? "Processing..." : "Generate Variant Inventory"}
      </button>
    </div>
  );
}

export default VariantInventoryGenerator;
